module.exports = __webpack_public_path__ + "static/media/SubProcess.3011662e.svg";